import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const RefreshData = () => {
    const history = useNavigate();
    useEffect(() => {
        localStorage.clear()
        history('/')
    }, [])
    return (
        <div>Loading . . .</div>
    )
}

export default RefreshData